import { PaywallAwareButton } from '../components/PaywallAwareButton';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CareMapState } from './CareMapState';
import { IFreeTierLimits } from '../innerhive-plus/revenue-cat/IFreeTierLimits';
import { InnerhivePlusText } from '../components/InnerhivePlusText';
import { OrganizationsState } from '../organizations/OrganizationsState';
import { NewCareMapWizard } from '../wizard/mini-wizard/wizards/NewCareMapWizard';

export const AddCareMapButton: React.FC<{closeMenu?: () => void}> = ({ closeMenu }) => {
    const newCareMapMiniWizard = useInstance(NewCareMapWizard);

    const orgState = useInstance(OrganizationsState);
    useSubscription(() => orgState);

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const maps = careMapState.getCareMaps();

    const requiresInnerhivePlus = (limits: IFreeTierLimits) => {
        return maps.length >= limits.freeCaremapsOwned && !careMapState.getIncompleteCareMap();
    };

    const innerhivePlusMessage = <>Limit reached, get <InnerhivePlusText/> to add</>;

    const closeAndExecute = (handler: () => void) => {
        if (closeMenu) {
            closeMenu();
        }
        setTimeout(() => {
            handler();
        }, 350);
    };

    const onAddCareMap = async () => {
        closeAndExecute(newCareMapMiniWizard.start);
    };

    return (
        <PaywallAwareButton
            requiresInnerhivePlus={requiresInnerhivePlus}
            innerhivePlusMessage={innerhivePlusMessage}
            expand="block"
            data-id="add-care-map-button"
            fill="outline"
            triggerSource="care map limit"
            onClick={onAddCareMap}
        >
            +&nbsp;Add Care Recipient
        </PaywallAwareButton>
    );
};
